import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';


import { IntlProvider } from "react-intl";
import koMsg from 'lang/ko.json';
import jpMsg from 'lang/jp.json';
import enUSMsg from 'lang/en-US.json';


const locale = localStorage.getItem('locale') ?? "ko"; //default korean
const messages = { "en-US": enUSMsg, ko: koMsg, jp: jpMsg}[locale];

const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export default class App extends Component {

  constructor(props) {
    super();
  }

  render() {
    return (
      <IntlProvider locale={locale} messages={messages}>
        <ThemeProvider theme={theme}>
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </ThemeProvider>
      </IntlProvider>
    );
  }
}
